export default __webpack_public_path__ + "static/AdvertisementBanner-4c37a23dead633e07135ded0cbc303ef.jpg";